<template>
  <div>
    <!-- <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#5dc596" :is-full-screen="true" /> -->
    <div class="md-layout-item">
      <div class="md-layout">
        <div
          class="
            md-layout-item md-size-100 md-medium-size-100 md-small-size-100
          "
        >
          <md-card style="margin: 0px">
            <md-card-header class="md-card-header-icon">
              <div
                class="card-icon"
                style="background-color: #425276 !important"
              >
                <i class="fas fa-map-marked-alt"></i>
              </div>
              <span style="font-size: large; font-weight: 500"
                >Office Location</span
              >
            </md-card-header>
            <md-card-content>
              <md-table
                :value="queriedData"
                :md-sort.sync="currentSort"
                :md-sort-order.sync="currentSortOrder"
                :md-sort-fn="customSort"
                class="paginated-table table-striped table-hover"
              >
                <md-table-toolbar>
                  <md-field>
                    <md-input
                      type="search"
                      class="mb-3"
                      clearable
                      style="width: 200px"
                      placeholder="Search records"
                      v-model="searchQuery"
                    >
                    </md-input>
                  </md-field>
                  <!-- <md-button class="md-info md-round notice-modal" @click="modalOpen = true" style="float:right;">
              Add Office Location
            </md-button> -->
                  <md-button
                    style="
                      z-index: 9999 !important;
                      position: absolute !important;
                      bottom: 1vh !important;
                      right: 10px !important;
                    "
                    class="md-info md-just-icon md-round"
                    @click="modalOpen = true"
                  >
                    <md-icon>add</md-icon>
                  </md-button>
                </md-table-toolbar>
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    md-label="Office Location"
                    md-sort-by="location"
                  >
                    {{ item.location }}
                  </md-table-cell>
                  <md-table-cell
                    style="width: 30%"
                    md-label="Address"
                    md-sort-by="address"
                  >
                    {{ item.address }}
                  </md-table-cell>
                  <md-table-cell md-label="City" md-sort-by="city">
                    {{ item.city }}
                  </md-table-cell>
                  <md-table-cell md-label="Zip_Code" md-sort-by="zipCode">
                    {{ item.zipCode }}
                  </md-table-cell>
                  <md-table-cell md-label="State" md-sort-by="state">
                    {{ item.state }}
                  </md-table-cell>
                  <md-table-cell md-label="Country" md-sort-by="country">
                    {{ item.country }}
                  </md-table-cell>
                  <md-table-cell md-label="Active">
                    <md-checkbox v-model="item.status" disabled></md-checkbox>
                  </md-table-cell>
                  <md-table-cell md-label="Actions">
                    <md-button
                      class="md-just-icon md-warning md-simple"
                      @click.native="editOfficeLocation(item)"
                    >
                      <md-icon>dvr</md-icon>
                    </md-button>
                    &emsp;&nbsp;&nbsp;&nbsp;
                    <md-button
                      class="md-just-icon md-danger md-simple"
                      @click.native="handleDelete(item)"
                    >
                      <md-icon>close</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
              <div class="">
                <p class="card-category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
              </div>
              <pagination
                class="pagination-no-border pagination-success"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </pagination>
            </md-card-actions>
          </md-card>
        </div>
      </div>
    </div>
    <modal
      @close="modalclose"
      id="modalOpen"
      v-if="modalOpen == true"
      style="width: 100%; margin-top: 40px"
      class="modalInvestClass"
    >
      <template slot="header">
        <div class="md-layout md-gutter" style="margin-top: 10px">
          <div class="md-layout-item" style="text-align: left !important">
            <span style="font-size: large; font-weight: 500"
              >Add Office Location Details</span
            >
          </div>
          <div class="md-layout-item" style="text-align: right !important">
            <span @click="modalclose()">
              <md-icon @click="modalclose()">close</md-icon>
            </span>
          </div>
        </div>

        <!--<md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalclose">
          <md-icon>clear</md-icon>
        </md-button>
        <div>
          <p style="margin:0px;text-align:left;padding-left:10px;">
            <span style="font-size: large;font-weight: 500;">Add Office Location Details</span>
          </p>
        </div> -->
        <!-- <span>Add Office Location Details</span>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalclose">
          <md-icon>clear</md-icon>
        </md-button> -->
      </template>
      <template slot="body">
        <add-office :userid="userid" />
      </template>
      <div class="modal-footer" style="display: none"></div>
    </modal>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import $ from "jquery";
import { APIService } from "../../../../apiservice";
import { Modal } from "@/components";
// import addOffice from "./officePages/addOffice.vue";

export default {
  components: {
    Pagination,
    Modal,
    // addOffice
  },
  props: {
    userid: {
      type: String,
    },
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      currentSort: "name",
      currentSortOrder: "asc",
      loading: false,
      showCard: false,
      showupdate: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      master: {
        name: "",
        type: "purpose",
        status: true,
      },
      noticeModal: false,
      updatemodal: false,
      //   footerTable: ["Full Name", "Email", "Country", "Created", "Status", "Actions"],
      searchQuery: "",
      propsToSearch: ["name", "email", "status"],
      tableData: [],
      transactName: [],
      searchedData: [],
      fuseSearch: null,
      tempMaster: {},
      modalOpen: false,
    };
  },
  created: function () {
    this.getOfficeDetails();
  },
  methods: {
    modalclose() {
      this.modalOpen = false;
    },
    getOfficeDetails() {
      let self = this;
      APIService.getOfficeLocationDetails(this.userid).then((res) => {
        if (res.status == 200) {
          self.tableData = res.data;
          this.fuseSearch = new Fuse(this.tableData, {
            keys: ["name"],
            threshold: 0.3,
          });
        }
      });
    },
    // addMaster(){
    //   let self = this;
    //   APIService.saveMasterData(self.master).then(
    //     res => {
    //       if(res.status == 200){
    //         self.showCard = false;
    //         self.getMaster();
    //       }
    //     }
    //   )
    // },
    updateMaster() {
      let self = this;
      self.tempMaster.name = self.master.name;
      self.tempMaster.status = self.master.status;
      APIService.editMaster(self.tempMaster).then((res) => {
        if (res.status == 200) {
          this.showupdate = false;
          self.getOfficeDetails();
        }
      });
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        a[sortBy] = a[sortBy] ? a[sortBy] : "";
        b[sortBy] = b[sortBy] ? b[sortBy] : "";
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    editOfficeLocation(item) {
      let self = this;
      self.office.location = item.location;
      self.office.address = item.address;
      self.office.city = item.city;
      self.office.zipCode = item.zipCode;
      self.office.state = item.state;
      self.office.country = item.country;
      self.office.status = item.status;
      this.showCard = false;
      this.showupdate = true;
    },
    handleDelete(item) {
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: `You won't be able to revert this!`,
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonClass: "md-button md-success",
      //   cancelButtonClass: "md-button md-danger",
      //   confirmButtonText: "Yes, delete it!",
      //   buttonsStyling: false
      // }).then(result => {
      //   if (result.value) {
      //     this.deleteRow(item);
      //   }
      // });
      this.deleteRow(item);
    },
    deleteRow(item) {
      APIService.removeOfficeLocation(item).then((res) => {
        if (res.status == 200) {
          this.getOfficeDetails();
        }
      });
    },
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.row1 {
  width: 50%;
  position: relative;
  top: 20px;
  float: right;
}

.row2[data-v-3984c662] {
  width: 50%;
  position: relative;
  top: 20px;
}

.emailTab {
  width: 30% !important;
}

.modalstyle {
  padding-left: 45%;
}
.modalInvestClass {
  overflow: hidden !important;
}
</style>